import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { getChildbirthOBSelector } from '../selectors'
import { setAddToTimeLine } from '../store/childbirthOB.actions'
import { ChildbirthOBConstants } from '../store/childbirthOB.constants'
import { IChildbirthOBState } from '../store/childbirthOB.types'
import { addChildbirthOBItem } from '../../../timeline/store/timeline.actions'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import { handleNemsisCodeError, getUpdatedProcedureStateWithNemsisCode } from '../../../../utilities/nemsisCode.util'

export function* saveChildbirthOB() {
  let childbirthOBState: IChildbirthOBState = yield select(getChildbirthOBSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  const { nemsisCodeOptions } = yield select(getProcedureStateSelector)

  if (!pcrID) {
    // todo: add to audit log
    return
  }

  try {
    childbirthOBState = getUpdatedProcedureStateWithNemsisCode({
      procedureState: childbirthOBState,
      actionField: (s) => s.action?.name,
      filter1Field: null,
      filter2Field: null,
      filter3Field: null,
      nemsisCodeOptions,
    })
  } catch (error: unknown) {
    childbirthOBState = handleNemsisCodeError(error, childbirthOBState)
  }

  const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
  if (pcrDoc.patient?.childbirthOBStateList && pcrDoc.patient?.childbirthOBStateList.length) {
    const index = pcrDoc.patient?.childbirthOBStateList?.findIndex(
      (childbirthOB) => childbirthOB.key === childbirthOBState.key
    )
    if (index !== -1) {
      pcrDoc.patient.childbirthOBStateList[index] = childbirthOBState
    } else {
      pcrDoc.patient?.childbirthOBStateList.push(childbirthOBState)
    }
  } else {
    pcrDoc.patient = { ...pcrDoc.patient, childbirthOBStateList: [childbirthOBState] }
  }
  try {
    const pcrDocUpdated = { ...pcrDoc, patient: { ...pcrDoc.patient } }
    yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    yield put(setAddToTimeLine(true))
    yield put(addChildbirthOBItem())
  } catch (e) {
    yield put(throwPcrException(`saveChildbirthOB() error: ${e}`))
  }
}

export function* saveChildbirthOBSaga() {
  yield takeLatest(
    [
      ChildbirthOBConstants.SAVE_CHILDBIRTHOB,
      ChildbirthOBConstants.SET_DATE,
      ChildbirthOBConstants.SET_TIME,
      ChildbirthOBConstants.SET_DATE_TIME,
      ChildbirthOBConstants.SET_ASSESSED_BY,
      ChildbirthOBConstants.SET_RESPONSE,
      ChildbirthOBConstants.SET_RESPONSE_PNNV,
      ChildbirthOBConstants.SET_PROCEDURE_COMPLICATIONS,
      ChildbirthOBConstants.SET_AUTHORIZATION,
      ChildbirthOBConstants.SET_ATTEMPTS,
      ChildbirthOBConstants.SET_ROLE_PERFORMING,
      ChildbirthOBConstants.SET_ROLE_PERFORMING_PNNV,
      ChildbirthOBConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
      ChildbirthOBConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
      ChildbirthOBConstants.SET_ACTION,
      ChildbirthOBConstants.SET_PTA,
    ],
    performWithMutexHOG,
    saveChildbirthOB
  )
}
